import { gsap } from 'gsap';

export default function LandingLoader(timing){
  let target = $('*[data-barba-introductionscreen]');

  if(target){
    //gsap.set(target, {autoAlpha: 1});

  }
  this.init = function(){
    if(target){
        console.log("=================>",target);
      let fade = gsap.timeline( {
        onComplete: function(){

          $(target).remove();
          
        }
      });
     
    fade.to('#introduction-screen svg #shadowAnimation01',
           {
              attr: {
                dx:-6,
                dy:-6,
              },
              duration:.8,

              ease:'circ.inOut',
             
      },"shadowAnimation");
    fade.to('#introduction-screen .step-01-blur',{
        attr: {
            stdDeviation:7.5,
        },
        duration:.65,

        ease:'circ.inOut',
    },'shadowAnimation')
    fade.from('#introduction-screen #grpPathStep01,#introduction-screen #grpPathStep02',{
      duration:.65,
      transformOrigin:'50% 75%',
      scale:.95,
      ease:'circ.inOut',
    },'shadowAnimation')
    fade.to('#introduction-screen #grpPathStep01,#introduction-screen #grpPathStep02',{
      duration:.65,
      transformOrigin:'50% 75%',
      //scale:1.05,
      ease:'circ.inOut',
    },'shadowAnimation')
    fade.to('#introduction-screen svg #shadowAnimation02',
           {
            attr: {
              dx:6,
              dy:6,
            },
            duration:.65,
            ease:'circ.inOut',
             
      },'shadowAnimation');
    // // // // // 
    
    //
  
    fade.to('#introduction-screen',
    {
        onStart:()=>{
          window.appEvent.trigger('app:transitionGlobal:end');

        },
        autoAlpha:0,
        duration:.65,
        delay:1.3,
        ease:'circ.inOut',
        onComplete:()=>{
  
        }
        
    },'shadowAnimation');
  
   

 

    }
    else{
      return false;
    }
  }
}
